import { v4 } from "uuid";

import { IRegistrationConfirmationResponse } from "modules/authentication/application/types/IRegistrationConfirmationResponse";

export const createRegistrationConfirmationResponse = (
  response?: Partial<IRegistrationConfirmationResponse>
): IRegistrationConfirmationResponse => {
  return {
    appointmentId: v4(),
    ...response,
  };
};
